export default __webpack_public_path__ + "static/media/themebel_medium.3cb4cdd9.svg";